import { Box, Modal, Typography } from "@mui/material";
import { useEffect } from "react";
import { useState } from "react";
import checkPhone from "../../assets/image/onlineCheck.png";
import VerificationInput from "react-verification-input";
import Timer from "./timer";
import Vector from "../../assets/SVG/vector";
import { postUserCheckCode } from "../../api/signin";
import { setToken } from "../../api/token";
import { doChangePhone } from "../../api/user";

export default function CheckPhone({
  show,
  setShow,
  setLevel,
  dataCheckCode,
  setDataCheckCode,
  group,
  cheangPhoneNum,
}) {
  const [open, setOpen] = useState(false);
  const [code, setCode] = useState();
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setShow(false);
    setOpen(false);
  };
  useEffect(() => {
    if (show === true) {
      setOpen(true);
    }
  }, [show]);
  useEffect(() => {
    if (code) setDataCheckCode({ ...dataCheckCode, code: Number(code) });
  }, [code]);
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 750,
          height: 350,
          bgcolor: "white",
          boxShadow: 24,
          p: 5,
          borderRadius: "23px",
        }}
      >
        <Box display="flex" alignItems="center" gap="20px">
          <Box width="40%" borderLeft="1px solid #98C2CB" height={"350px"}>
            <img src={checkPhone} />
          </Box>
          <Box display="grid" height="300px">
            <Box>
              <Typography fontSize="18px">
                {"تایید شماره تلفن همراه"}
              </Typography>
              <Typography color="var(--emr-disable)" fontSize="16px">
                {"جهت تایید شماره تلفن همراه، کد پیامک شده را وارد نمایید."}
              </Typography>
            </Box>
            <Box>
              <VerificationInput
                onChange={setCode}
                // inputField={{
                //   onChange: (e) => {
                //     // setValue(e.nativeEvent.target.value);
                //     console.log(e);
                //   },
                // }}
                length={6}
                validChars="0-9"
                removeDefaultStyles
                classNames={{
                  container: "container",
                  character: "character",
                  characterInactive: "character--inactive",
                  characterSelected: "character--selected",
                }}
              />
              <Timer initialMinute={2} initialSeconds={0} />
            </Box>
            <Box mt="20px" display="flex" justifyContent="center" height="70px">
              <button
                style={{
                  border: "none",
                  //   width: "150px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  backgroundColor: "white",
                  // boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.08)",
                  padding: "12px 0px",
                  marginTop: "20px",
                  borderRadius: "8px",
                }}
                onClick={handleClose}
              >
                <Box sx={{ transform: "rotate(180deg)", mt: "-4px" }}>
                  <Vector color="#626262" />
                </Box>
                <Typography
                  fontWeight={"bold"}
                  fontSize="13px"
                  color="#626262"
                  mx="10px"
                >
                  ویرایش شماره تلفن همراه
                </Typography>
              </button>
              <button
                style={{
                  border: "none",
                  width: "150px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  backgroundColor: "#6CBBC7",
                  boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.08)",
                  padding: "12px 0px",
                  marginTop: "20px",
                  borderRadius: "8px",
                }}
                onClick={() => {
                  if (cheangPhoneNum) {
                    doChangePhone(dataCheckCode)
                      .then(() => {
                        handleClose();
                      })
                      .catch(() => {});
                  } else {
                    postUserCheckCode(dataCheckCode)
                      .then((x) => {
                        setLevel(2);
                        handleClose();
                        if (group) {
                          setToken(x);
                        }
                      })
                      .catch((err) => console.log(err));
                  }
                }}
              >
                <Typography fontSize="16px" color="white" ml="10px">
                  تایید
                </Typography>
              </button>{" "}
            </Box>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
}
